import { Component, OnInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { NotificationService } from '../../shared/services/notification.service';
import { OPCConstant } from '../../opc-app/opc.const';
import { Message } from 'primeng/api';
import { PartGroup } from '../../opc-app/partgroup/partgroup.model';
import { PartCategory } from '../../opc-app/partcategory/partcategory.model';
import { ProductLine } from '../../opc-app/productline/productline.model';
import { ProductService } from '../../shared/services/product.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { ProductLinePartGroup } from '../../opc-app/partgroup/productlinepartgroup.model';
import { PartGroupService } from '../../shared/services/partgroup.service';
import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operator/filter';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PagerService } from '../../shared/services/pager.service';

@Component({
  selector: 'app-partgroup',
  templateUrl: './partgroup.component.html',
})
export class PartGroupComponent implements OnInit, OnDestroy {
  currentUrl: string;
  partGroups: PartGroup[];
  partCategories: PartCategory[];
  productLines: ProductLine[];
  productLineOptions: SelectItem[] = [];
  added: boolean;
  newPartGroup: PartGroup;
  notifications: Message[] = [];
  loading = false;
  pagedItems: any;
  startIndex: number;
  endIndex: number;
  selectedChar: string = '';
  private destroy$ = new Subject<void>();
  private isBackButtonClicked = false;

  constructor(private _partGroupService: PartGroupService,
              private notifyService: NotificationService,
              private spinner: NgxSpinnerService,
              private _router: Router,
              private route: ActivatedRoute,
              private _pagerService: PagerService)
              {
                  this.currentUrl = this._router.url;
              }

  @HostListener('window:popstate', ['$event'])
  onpopstate(event: any) {
    this.isBackButtonClicked = true;
    this._partGroupService.setSharedBackButtonValue(this.isBackButtonClicked);
  }

  ngOnInit(): void {
    var isPageReload = (performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined).type === "reload";
    this.loadPartGroupData(isPageReload);
  }

  // To load the part group data
  loadPartGroupData(isPageReload) {
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        isPageReload = false;
        this._partGroupService.setSharedPageValue(isPageReload);
      }
    })

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const filter = params['filter'];
      const page = params['page'];
      var isPageRefresh = false;
      var isBackButtonEnabled = false;
      this._partGroupService.sharedPageValue$.subscribe(val => {
        isPageRefresh = val;
      });
      this._partGroupService.sharedBackButtonValue$.subscribe(val => {
        isBackButtonEnabled = val;
      });
      if (!isPageRefresh && isPageReload && !isBackButtonEnabled) {
        this.loading = true;
        this._partGroupService.setSharedPageValue(isPageReload);
        this.spinner.show();
        this.getAllPartGroups();
      }
      else if (this._router.url.includes('/manage/partgroup?filter') && filter != 'All' && !isPageReload) {
        this.loading = true;
        this.spinner.show();
        this.getPartGroupsByCharacter(filter);
        this._partGroupService.setSharedPageValue(isPageReload);
      }
      else if (this._router.url.includes('/manage/partgroup?filter') && filter != 'All' && isBackButtonEnabled && isPageReload) {
        this.loading = true;
        this.spinner.show();
        this.getPartGroupsByCharacter(filter);
        this._partGroupService.setSharedPageValue(isPageReload);
      }
      else {
        this._partGroupService.setSharedPageValue(isPageReload);
        this.loading = true;
        this.spinner.show();
        this.getAllPartGroups(page);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCharacterSelected(letter: string): void {
    this.selectedChar = letter;
    this._partGroupService.setSharedValue(letter);
    this._router.navigate([], {
      queryParams: { filter: letter,page: 1 }, 
      queryParamsHandling: 'merge',
    });
    this._pagerService.setPageSize(8);
    this.getPartGroupsByCharacter(this.selectedChar);
  }

  getAllPartGroups(pageNumber = 1) {
    this.loading = true;
    this.spinner.show();
    this.selectedChar = '';
    this._partGroupService.setSharedValue('All');
    this._router.navigate([], {
      queryParams: { filter: 'All', page: pageNumber },
      queryParamsHandling: 'merge',
    });
    this._partGroupService.getAllPartGroups().subscribe(res => {
    this.getPartGroups(res);
    });
  }

  getPartGroupsByCharacter(char: string) {
    this.loading = true;
    this.spinner.show();
    this.selectedChar = char;
    this._partGroupService.setSharedValue(char);
      this._partGroupService.getPartsByCharacter(char).subscribe(res => {
      this.getPartGroups(res);
    });
  }

  getPartGroups(res) {
    this.partGroups = res.item1;
    this.partCategories = res.item2;
    this.productLines = res.item3;
    for (let i = 0; i < this.productLines.length; i++) {
      this.productLineOptions.push({
        label: this.productLines[i].productLineDesc,
        value: this.productLines[i].productLineID
      });
    }

    this.partGroups.forEach(e => {
      e['ListOfIndexOrderIds'] = this.partGroups.filter(d => d.partCategoryID === e.partCategoryID).map(e => e.indexOrderID).sort((a, b) => {
        return a - b;
      });
    });

    this.spinner.hide();
    this.loading = false;
  }

  setPageData(data: any) {
    this.pagedItems = this.partGroups.slice(data.startIndex, data.endIndex);
    this.startIndex = data.startIndex;
    this.endIndex = data.endIndex;
  }

  onSubmit(event) {
    if (event) {
      let page = this.route.snapshot.queryParamMap.get('page');
      this.selectedChar ? this.getPartGroupsByCharacter(this.selectedChar) : this.getAllPartGroups(parseInt(page));
      this.added = false;
      this.newPartGroup = new PartGroup();
      const pg = this.partGroups.find(p => p.partGroupID === event.partGroupID);
      if (pg) {
        const index = this.partGroups.indexOf(pg);
        this.partGroups[index] = event;
      }
      else {
        this.partGroups.unshift(event);
        this.notifications = this.notifyService.growlNotification('succ', OPCConstant.ADDED_SUCCESS);
      }
      this.pagedItems = this.partGroups.slice(this.startIndex, this.endIndex);
    }
  }

  onDelete(event, item) {
    if (event && item) {
      const index = this.partGroups.findIndex(p => p.partGroupID == item.partGroupID);
      this.partGroups.splice(+index, 1);
      this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
    } else {
      this.added = false;
    }
  }

  onAddNew() {
    this.added = true;
    this.newPartGroup = new PartGroup();
    this._partGroupService.addIndex = false;
  }

  onHandleError() {
    this.notifications = this.notifyService.growlNotification('fail', OPCConstant.PG_DELETE_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/partgroup/partgroup.component.ts